var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:`${_vm.classNames}`,attrs:{"type":"text","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }